import React from 'react';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import noImage from '@images/icons/no-image.jpg';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import RemoveRoundedIcon from '@mui/icons-material/RemoveRounded';
import { useDispatch, useSelector } from 'react-redux';
import { TProduct } from '../../../types/Common';
import { cartSelector } from '../../../store/user/user.selector';
import { deleteCart, updateCart } from '../../../store/user/user.reducer';
import commafy from '../../../utils/commafyHelper';
import './cart.scss';

interface CartCardProps {
  product: TProduct;
}

const CartCard: React.FC<CartCardProps> = (props) => {
  const dispatch = useDispatch();
  const cart = useSelector(cartSelector) || [];

  const { product } = props;
  const { productName, off = 0, price, productId, shortDescription, productPic } = product;

  const quantity = cart.filter((i: TProduct) => i.productId === productId)[0]?.quantity || 1;

  return (
    <Box className='cardCartContainer'>
      <Box display='flex' width='80%'>
        <Box>
          <img src={productPic || noImage} width={150} height={100} alt='' />

          <Box className='countContainer' gap={1}>
            <IconButton
              sx={{ padding: '0' }}
              onClick={() => dispatch(updateCart({ productId, quantity: quantity + 1 }))}
            >
              <AddRoundedIcon color='primary' />
            </IconButton>
            <Typography color='text.main' fontWeight='bold'>
              {quantity}
            </Typography>

            <IconButton
              sx={{ padding: '0' }}
              onClick={() =>
                quantity > 1
                  ? dispatch(updateCart({ productId, quantity: quantity - 1 }))
                  : dispatch(deleteCart(productId))
              }
            >
              {quantity > 1 ? (
                <RemoveRoundedIcon color='primary' />
              ) : (
                <DeleteOutlineRoundedIcon color='primary' />
              )}
            </IconButton>
          </Box>
        </Box>

        <Box className='contentContainer'>
          <Typography color='text.main' fontWeight='bold'>
            {productName}
          </Typography>
          <Typography className='cartDescription' color='text.light'>
            {shortDescription}
          </Typography>
        </Box>
      </Box>

      <Grid container={false} mt={2}>
        <Grid item lg={4} xs={12} className='flexEndGridContainer'>
          <Box>
            <Box className='flexCenter' gap={0.5}>
              <Typography fontWeight='bold'>
                {commafy(price - Math.floor((price * off) / 100))}
              </Typography>
              <Typography className='unit'>تومان</Typography>
            </Box>

            {off !== 0 && (
              <Typography color='text.lighter' className='priceContainer'>
                {commafy(price)}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CartCard;
